import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Auth from "@/views/Auth.vue";
import AdminUsers from "@/views/AdminUsers.vue";
import AdminUser from "@/views/AdminUser.vue";
import PermissionDenied from "@/views/PermissionDenied.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    meta: {
      requiresAuth: true
    },
    component: Home
  },
  {
    path: "/auth",
    name: "Auth",
    component: Auth
  },
  {
    path: "/permission-denied",
    name: "PermissionDenied",
    component: PermissionDenied
  },
  {
    path: "/admin/users",
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    name: "AdminUsers",
    component: AdminUsers
  },
  {
    path: "/admin/users/:userUid",
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    name: "AdminUser",
    component: AdminUser
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/Profile.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
